//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CollapseTransition from '@/utils/collapseTransition'
import { setStorage, getStorage } from '@/utils/storage'
import { GetProblem } from '@/service/request'

export default {
	components: {
		CollapseTransition
	},

	data () {
		return {
			industry: [
		      {
		        name: '便利超市', id: '101'
		      },
		      {
		        name: '餐饮行业', id: '102'
		      },
		      {
		        name: '烘焙行业', id: '107'
		      },
		      {
		        name: '母婴行业', id: '105'
		      },
		      {
		        name: '宠物行业', id: '106'
		      },
		      {
		        name: '美业休闲', id: '108'
		      }
		    ],
		  	activeIndustryName: '',
		  	problemList: [],
		  	blogUrl: 'https://blog.pospal.cn',
		  	isIndustryPopShow: false,
		  	curIndustry: {}
		}
	},

	computed: {
		
	},

	methods: {
		getIndustryKey() {
			let key = {};
		    this.industry.forEach((val) => {
		      key[val.id] = { ...val };
		    });
		    return key;
		},
		setProblemList() {
			let requestId;

			switch (this.curIndustry.id) {
			  case "101":
			    requestId = '01';
			    break;
			  case "102":
			    requestId = '02';
			    break;
			  case "107":
			    requestId = '03';
			    break;
			  case "105":
			    requestId = '04';
			    break;
			  case "106":
			    requestId = '05';
			    break;
			  case "108":
			    requestId = '06';
			    break;
			}

			GetProblem(requestId)
			.then((data) => {
				let problemList = data.data || [];
		        this.adaptData(problemList);
		        this.problemList = problemList;
		        
			})
		},
		adaptData(soure) {
			soure.forEach((val) => {
		      val.isShowMore = false;
		      val.children01 = val.children.slice(0, 3);
		      val.children02 = val.children.slice(3);
		    })
		},
		handleCategoryClick(item) {
			if (item.children02.length === 0){
		      return;
		    }
		    item.isShowMore = !item.isShowMore;
		},
		handleProblemItemClick(item) {
			setStorage('problem_item', item);
			this.$router.push('/problemDetail');
		},
		handleCheckerClick(id) {
			this.isIndustryPopShow = false;
			this.curIndustry = this.industryKey[id];
			this.activeIndustryName = this.curIndustry.name;
			this.setProblemList();
			setStorage('industry_id', id);
		},
		handleHeaderClick() {
			this.isIndustryPopShow = true;
		}
	},

	created () {
	
		let industryId = getStorage('industry_id');
		if (industryId === null) {
			this.$router.push('/industry');
			return
		}

		this.industryKey = this.getIndustryKey();
		this.curIndustry = this.industryKey[industryId];
		this.activeIndustryName = this.curIndustry.name;

		this.setProblemList();
	},
}



// WEBPACK FOOTER //
// ./src/views/problem/problem.vue